import { render } from "./AlertMsg.vue?vue&type=template&id=22f738fe&scoped=true"
import script from "./AlertMsg.vue?vue&type=script&lang=js"
export * from "./AlertMsg.vue?vue&type=script&lang=js"

import "./AlertMsg.vue?vue&type=style&index=0&id=22f738fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22f738fe"]])

export default __exports__